import React from 'react';

import {
    EMessageDirection, IMessageComplete, EMessageType, IOutcommingTextInput,
    IIncommingTextInput, IOutcommingNode, IIncommingNode, IIncommingInfo, IHistory
} from '../../../hooks/Messages';
import History from './History';
import IncommingInfo from './IncommingInfo';
import IncommingNode from './IncommingNode';
import IncommingTextInput from './IncommingTextInput';
import OutcommingNode from './OutcommingNode';
import OutcommingTextInput from './OutcommingTextInput';

import ErrorBoundary from '../../hoc/ErrorBoundary';

export interface IMessageProps extends IMessageComplete {
    scrollToBottom: () => void
}

function Message({ scrollToBottom, ...message }: IMessageProps) {
    switch (message.type) {
        case EMessageType.History:
            return (
                <History
                    {...message.payload as IHistory}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            );
        case EMessageType.Node:
            if (message.direction === EMessageDirection.Incomming) return (
                <IncommingNode
                    {...message.payload as IIncommingNode}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            );
            else return (
                <OutcommingNode
                    {...message.payload as IOutcommingNode}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            );
        case EMessageType.TextInput:
            if (message.direction === EMessageDirection.Incomming) return (
                <IncommingTextInput
                    {...message.payload as IIncommingTextInput}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            );
            else return (
                <OutcommingTextInput
                    {...message.payload as IOutcommingTextInput}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            );
        case EMessageType.Info:
            return (
                <IncommingInfo
                    {...message.payload as IIncommingInfo}
                    message={message}
                    scrollToBottom={scrollToBottom} />
            )
        default:
            return null;
    }
}

const SafeMessage = (props: IMessageProps) => <ErrorBoundary><Message {...props} /></ErrorBoundary>;

export default SafeMessage;
